import React, {Component} from 'react';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';
import _ from 'lodash';

import I18n from 'app/common/i18n';
import {bindDispatch} from 'app/utils/redux';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';
import * as enums from 'app/utils/enums';

import CompanySuccessIcon from 'app/assets/Academy-Success.svg';

import OnboardSuccessView from 'views/onboard-success';

class CompanySuccessContainer extends Component {

	componentWillMount() {
		let {company: {name, location, logins, companyId} } = this.props;

		if (!name.trim().length || _.isEmpty(logins)) {
			history.push(routePath.dashboardRoute);
		}
	}

	render() {
		let {company, actions} = this.props;

	  return (
	    <OnboardSuccessView 
	    	entity={company}
	    	entityType={enums.onboard_options.COMPANY}
	    	entityIcon={<CompanySuccessIcon className='svg-icon svg-4x'/>} 
	    	resetEntity={actions.resetCompany}/>
	  );
	}
}

const selector = createSelector(
  state => state.company,
  (company) => ({ company })
);


export default connect(selector, bindDispatch)(CompanySuccessContainer);



// WEBPACK FOOTER //
// ./src/containers/company/CompanyOnboardSuccessContainer.js